import { RocketAPI } from '@portal/rocket-api-client';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import BillingEditPlan from 'component/view/Settings/BillingEditPlan';

import { requireOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/billing/edit-plan/_tabs')({
  beforeLoad: requireOperation({
    options: () => RocketAPI.account.getUpdateAccountHostingPlanMutationOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: EditPlanTabsLayout,
});

function EditPlanTabsLayout() {
  return (
    <BillingEditPlan>
      <Outlet />
    </BillingEditPlan>
  );
}
